import BookingSearchForm from '../../../components/BookingSearchForm/BookingSearchForm';

export default function BookingSearchFormPage() {
  return <BookingSearchForm></BookingSearchForm>;
}
